<template lang="html">
  <b-form @submit.prevent="save" v-if="is_ready">
    <!-- <pre>{{form.product_type}}</pre> -->
    <h2>{{ form.id ? 'Modifica' : 'Nuovo' }} prodotto</h2>
    <div class="row">
      <div class="col-md-12" style="padding-top:10px;padding-bottom:20px;">
        Tutti i campi contrassegnati con '*' sono obbligatori
      </div>
    </div>
    <div class="row" v-if="$store.user.type == 'admin' && !form.id">
      <div class="col-md-8">
        <div v-if="users">
          <div class="subtitle">
            Scegli l'utente a cui aggiungere il prodotto
          </div>
          <b-select v-model="form.user_id">
            <option v-for="u in users" :key="u.id" :value="u.id">{{ u.company }} ({{ u.name }} {{u.surname}}) {{u.type}}</option>
          </b-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Nome prodotto*">
          <b-input v-model="form.name" required />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Quantità*">
          <b-input v-model="form.quantity" required />
        </b-form-group>
      </div>
      <div class="col-md-6 mb-3">
        <!-- <b-form-group label="Descrizione/note">
          <b-textarea v-model="form.notes" :disabled="$store.user.type == 'admin'" />
        </b-form-group> -->


        <b-form-group label="Descrizione/note">
          <b-textarea v-model="form.admin_notes"  />
        </b-form-group>
      </div>
      <div class="col-md-6 mb-3">
        <b-form-group label="Immagini*">
          <file-uploader
          :params="{ request_mode : 'false' }"
           v-model="form.images" accept="image/*"/>
        </b-form-group>
      </div>
      <div class="col-md-12" style="padding-bottom:20px;">
        <b-form-checkbox
          v-model="form.is_varie"
        >
        Il prodotto non è un pallet
        </b-form-checkbox>
      </div>

      <template v-if="!form.is_varie">

        <div class="col-md-12">
          <b-form-group label="Tipologia">
            <b-form-select v-model="form.product_type_id">
              <option :value="!pt.is_std ? pt.id : null">Fuori Standard</option>
              <option v-for="type in product_types" :value="type.id" :key="type.id">{{ type.code }}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3 fix-align" v-if="$store.user.type == 'admin'">
          <b-form-group label="Codice Prodotto*" :disabled="pt.is_std" >
            <b-input v-model="pt.code" />
          </b-form-group>
        </div>
        <div class="col-md-3 fix-align">
          <b-form-group label="Lato A corto (mm)*">
            <b-input v-model="pt.side_a" required :disabled="pt.is_std"/>
          </b-form-group>
        </div>
        <div class="col-md-3 fix-align">
          <b-form-group label="Lato B lungo (mm)*">
            <b-input v-model="pt.side_b" required :disabled="pt.is_std"/>
          </b-form-group>
        </div>
        <div class="col-md-3 fix-align" v-if="$store.user.type == 'admin'">
          <b-form-group label="Spessore delle tavole superiori(mm)">
            <b-input v-model="pt.thickness" :disabled="pt.is_std"/>
          </b-form-group>
        </div>
        <div class="col-md-4" v-if="$store.user.type == 'admin'">
          <b-form-group label="Peso (Kg)">
            <b-input v-model="pt.weight" :disabled="pt.is_std"/>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Portata (Kg)*">
            <!-- <b-input v-model="pt.weight_range" required :disabled="pt.is_std"/> -->
            <b-select v-model="pt.weight_range" :disabled="pt.is_std">
              <!-- <option v-if="filters.is_std">{{ filters.weight_range }}</option> -->
              <!-- <option :value="undefined">Qualsiasi</option> -->
              <option value="500">
                LEGGERO - da 1 a 500 kg circa (spessore tav. fino a 15 mm. con TAPPO 6/8 cm)
              </option>
              <option value="1000">
                FORTE - da 501 a 1000 Kg circa (spessore tav. da 16  a 20 mm. con TAPPO 9/10 cm.)
              </option>
              <option value="99999">
                ROBUSTO - da 1001 a 1500Kg circa (spessore tav. da 21 a 25 mm. con TAPPO 11/13 cm.)
              </option>
            </b-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          Numero vie
          <b-select v-model="pt.shape"  :disabled="pt.is_std">
            <option>2 vie</option>
            <option>4 vie</option>
            <option>americano</option>
          </b-select>
        </div>
        <div class="col-md-6">
          <b-checkbox v-model="pt.is_transpallet" :disabled="pt.is_std">
            Transpallet
          </b-checkbox>
          <b-checkbox v-model="pt.is_bounded" :disabled="pt.is_std">
            Perimetrato
          </b-checkbox>
          <b-checkbox v-model="pt.is_filled" :disabled="pt.is_std">
            Piano Pieno
          </b-checkbox>
          <b-checkbox v-model="pt.reversable" :disabled="pt.is_std">
            Reversibile
          </b-checkbox>
          <b-checkbox v-model="pt.opposite" :disabled="pt.is_std">
            Contrario
          </b-checkbox>
          <b-checkbox v-model="pt.is_plastic" :disabled="pt.is_std">
            Plastica
          </b-checkbox>
        </div>
        <div class="col-md-6" v-if="$store.user.type == 'admin'">
          Tavole
          <b-select v-model="pt.slab_count" :disabled="pt.is_std">
            <option>5</option>
            <option>7</option>
          </b-select>
        </div>

      </template>
      <template v-else>
        <div class="col-md-12">
          <b-form-group label="Descrizione annuncio">
              <b-textarea style="width:100%;" v-model="form.description" required />
          </b-form-group>
        </div>
      </template>

      <div class="col-md-12" v-if="$store.user.type == 'admin'">
        <!-- <b-form-group label="Descrizione/note">
          <b-textarea v-model="form.admin_notes" :disabled="! $store.user.type == 'admin'" />
        </b-form-group> -->

        <b-form-group label="Descrizione/note">
          <b-textarea v-model="form.notes" :disabled="! $store.user.type == 'admin'" />
        </b-form-group>
      </div>
      <!-- <div class="col-md-12 mt-2">
        <b-form-group label="Descrizione/note">
          <b-textarea v-model="pt.notes" :disabled="pt.is_std"/>
        </b-form-group>
      </div> -->
    </div>
    <div class="row">
        <div class="col-md-6 disponibilita-annuncio">
          Disponibilità annuncio
          <b-checkbox v-model="form.always_available" >
            Sempre Disponibile
          </b-checkbox>

        </div>
        <div class="col-md-6 disponibilita-annuncio">
          Data di scadenza annuncio
          <b-form-datepicker v-model="form.expiry_time">
          </b-form-datepicker>

        </div>



    </div>

    <div class="text-right">
      <b-form-group label="Prodotto Visibile" v-if="$store.user.type == 'admin'">
        <b-checkbox v-model="form.visible" v-if="$store.user.type == 'admin'">

        </b-checkbox>
      </b-form-group>
      <b-button variant="outline-danger" @click="$emit('close')">Annulla</b-button>
      &nbsp;
      <b-button type="submit" variant="primary" :disabled="is_saving">Salva</b-button>
    </div>
  </b-form>
</template>

<script>
import FileUploader from '@/components/file-uploader'


export default {
  components: {
    FileUploader,
  },
  props: ['form'],
  data() {
    return {
      product_types: [],
      is_ready: false,
      is_saving: false,
      users: null
    }
  },
  computed: {
    pt() {
      return this.form.product_type
    },
  },
  created() {
    this.refreshProductTypes()
    this.refreshUsers()
  },
  methods: {
    save() {
      this.is_saving = true
      console.log("salvatooooo")
      this.$http.post('products', this.form).then(res => {
        console.log("dati dal form:")
        console.log(res.data)
        this.$emit('close')
        this.$emit('saved', res.data)
      }).finally(
        ()=>{this.is_saving = true}
      )
    },
    refreshProductTypes() {
      this.$http.get('product-types', { params: { only_std: true }}).then(res => {
        this.product_types = res.data
        this.is_ready = true
        this.fixProductType()
      })
    },

    fixProductType() {
      let id = this.form.product_type_id
      let pt = this.form.product_type
      if (!id && (!pt || pt.id != id)) {
        this.$set(this.form, 'product_type', {})
      } else if (id != this.form.product_type.id) {
        this.$set(this.form, 'product_type', this._.cloneDeep(this.product_types.find(x => x.id == id)))
      }
    },
    refreshUsers() {
      this.$http.get('users').then(res => {
        this.users = res.data
      })
    }
  },

  watch: {
    'form.product_type_id'(){
      this.fixProductType()
    },
  }
}
</script>

<style lang="css" scoped>
  .disponibilita-annuncio{
    padding-top:30px;
    padding-bottom:20px;
  }
  .fix-align{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
</style>
